var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.9,
    height: 26.1,
    viewBox: "0 0 31.9 26.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1213",
    "data-name": "Grupo 1213",
    transform: "translate(-61.2 -45.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_901",
    "data-name": "Rect\\xE1ngulo 901",
    width: 31.9,
    height: 26.1,
    transform: "translate(61.2 45.7)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": " Group "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_902",
    "data-name": "Rect\\xE1ngulo 902",
    width: 6.8,
    height: 12.3,
    transform: "translate(73.8 50.6)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": " Path ",
    d: "M74.2,56.7a7.579,7.579,0,0,1,3-6.1,7.833,7.833,0,1,0-.1,12.3A8.14,8.14,0,0,1,74.2,56.7Z",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2942",
    "data-name": "Trazado 2942",
    d: "M89.8,56.7A7.81,7.81,0,0,1,82,64.5a7.4,7.4,0,0,1-4.8-1.7,7.812,7.812,0,0,0,1.3-11,7.993,7.993,0,0,0-1.3-1.3,7.812,7.812,0,0,1,11,1.3,8.933,8.933,0,0,1,1.6,4.9Z",
    fill: "#f79e1b"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2943",
    "data-name": "Trazado 2943",
    d: "M69.285,68.755v-1.3a.771.771,0,0,0-.715-.822,1,1,0,0,0-.825.367.759.759,0,0,0-.683-.367.683.683,0,0,0-.606.307v-.255h-.45v2.067h.454V67.618a.485.485,0,0,1,.415-.546.555.555,0,0,1,.091,0c.3,0,.45.195.45.545v1.151h.454V67.618a.487.487,0,0,1,.419-.546.507.507,0,0,1,.087,0c.307,0,.454.195.454.545v1.151ZM76,66.688h-.739v-.627H74.81v.627H74.4V67.1h.419v.951c0,.48.186.766.718.766a1.066,1.066,0,0,0,.563-.16l-.13-.385a.825.825,0,0,1-.4.116c-.216,0-.3-.138-.3-.346V67.1h.736Zm3.837-.052a.606.606,0,0,0-.545.3v-.251h-.446v2.067h.45V67.6c0-.342.147-.532.432-.532a.735.735,0,0,1,.282.052l.138-.433a1,1,0,0,0-.32-.056Zm-5.8.216a1.551,1.551,0,0,0-.843-.216c-.524,0-.865.251-.865.662,0,.337.25.544.713.609l.216.031c.247.034.364.1.364.216,0,.16-.165.251-.472.251a1.1,1.1,0,0,1-.687-.217l-.217.351a1.491,1.491,0,0,0,.9.268c.6,0,.942-.281.942-.675s-.272-.553-.722-.618l-.216-.03c-.195-.026-.35-.065-.35-.2s.147-.242.393-.242a1.344,1.344,0,0,1,.649.177Zm12.047-.216a.608.608,0,0,0-.545.3v-.251H85.1v2.067h.449V67.6c0-.342.147-.532.433-.532a.73.73,0,0,1,.281.052l.138-.433a.993.993,0,0,0-.32-.056Zm-5.795,1.081a1.043,1.043,0,0,0,1,1.082c.032,0,.065,0,.1,0a1.081,1.081,0,0,0,.744-.246l-.216-.364a.9.9,0,0,1-.541.186.664.664,0,0,1,0-1.323.9.9,0,0,1,.541.186l.216-.363a1.077,1.077,0,0,0-.744-.247,1.044,1.044,0,0,0-1.1.984.785.785,0,0,0,0,.1Zm4.212,0V66.688h-.45v.251a.783.783,0,0,0-.648-.3,1.081,1.081,0,1,0,0,2.162.783.783,0,0,0,.648-.3v.25h.45Zm-1.674,0a.625.625,0,1,1,0,.049C82.829,67.75,82.829,67.733,82.83,67.717ZM77.4,66.636a1.081,1.081,0,1,0,.03,2.162h0a1.254,1.254,0,0,0,.858-.281l-.216-.333a.982.982,0,0,1-.6.216.573.573,0,0,1-.619-.506h1.536v-.173a.983.983,0,0,0-.982-1.081Zm0,.4a.513.513,0,0,1,.523.5H76.845a.532.532,0,0,1,.549-.5Zm11.268.683V65.857h-.432v1.082a.785.785,0,0,0-.649-.3,1.081,1.081,0,0,0,0,2.162.784.784,0,0,0,.649-.3v.25h.432Zm.75.733a.212.212,0,0,1,.083.016.219.219,0,0,1,.067.043.2.2,0,0,1,.045.065.2.2,0,0,1,0,.16.223.223,0,0,1-.045.065.239.239,0,0,1-.067.043.213.213,0,0,1-.277-.108.2.2,0,0,1,0-.16.2.2,0,0,1,.045-.065.208.208,0,0,1,.067-.043.21.21,0,0,1,.089-.016Zm0,.366a.151.151,0,0,0,.063-.013.146.146,0,0,0,.05-.035.156.156,0,0,0-.05-.251.15.15,0,0,0-.063-.012.167.167,0,0,0-.062.012.154.154,0,0,0-.052.035.16.16,0,0,0,0,.216.154.154,0,0,0,.052.035.163.163,0,0,0,.069.013Zm.013-.257a.087.087,0,0,1,.057.017.055.055,0,0,1,.019.045.051.051,0,0,1-.015.039.08.08,0,0,1-.045.02l.062.071h-.049l-.059-.071h-.019v.071h-.041v-.19Zm-.047.036v.052h.047a.039.039,0,0,0,.026,0,.021.021,0,0,0,0-.019.023.023,0,0,0,0-.02.057.057,0,0,0-.026,0Zm-2.379-.878a.625.625,0,1,1,0,.049C87.007,67.754,87.007,67.738,87.008,67.721Zm-15.187,0V66.688h-.45v.251a.783.783,0,0,0-.648-.3,1.081,1.081,0,1,0,0,2.162.783.783,0,0,0,.648-.3v.25h.45Zm-1.674,0a.583.583,0,1,1-.005.054c0-.018,0-.036,0-.054Z",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.fb5ee626996a7782b2cae7cd42b812a8.svg";
export { ForwardRef as ReactComponent };